var map = {
	"./0f7968-hover.png": 43990,
	"./1153FF-hover.png": 56457,
	"./215F9B-hover.png": 53867,
	"./61b695-hover.png": 87935,
	"./65AC50-hover.png": 6248,
	"./789c4a-hover.png": 41631,
	"./7dff7d-hover.png": 43314,
	"./90EE90-hover.png": 30109,
	"./9a5454-hover.png": 1123,
	"./9e3eff-hover.png": 68009,
	"./A80000-hover.png": 14204,
	"./C04F15-hover.png": 13746,
	"./D2A000-hover.png": 28854,
	"./FF0000-hover.png": 94471,
	"./FF5C0C-hover.png": 95813,
	"./FF6347-hover.png": 33140,
	"./FFA500-hover.png": 51251,
	"./FFFF00-hover.png": 935,
	"./a244ff-hover.png": 79767,
	"./a346ff-hover.png": 87585,
	"./aaffff-hover.png": 66666,
	"./acff59-hover.png": 99229,
	"./adff5b-hover.png": 37267,
	"./ceceff-hover.png": 57332,
	"./f3ff00-hover.png": 99836,
	"./ffa346-hover.png": 7105,
	"./ffa851-hover.png": 99821,
	"./ffaf60-hover.png": 98175,
	"./ffff51-hover.png": 27500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56114;